/**
 * @tabler/icons-react v2.10.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShieldExclamation = createReactComponent(
  "shield-exclamation",
  "IconShieldExclamation",
  [
    [
      "path",
      {
        d: "M15.04 19.745c-.942 .551 -1.964 .976 -3.04 1.255a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .195 6.015",
        key: "svg-0"
      }
    ],
    ["path", { d: "M19 16v3", key: "svg-1" }],
    ["path", { d: "M19 22v.01", key: "svg-2" }]
  ]
);

export { IconShieldExclamation as default };
//# sourceMappingURL=IconShieldExclamation.js.map
